export const getGroupGradient = (id: string = '') => {
  const gradients = [
    'linear-gradient(135deg, #FF9966 0%, #FF5E62 100%)',
    'linear-gradient(135deg, #56CCF2 0%, #2F80ED 100%)',
    'linear-gradient(135deg, #4776E6 0%, #8E54E9 100%)',
    'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)',
    'linear-gradient(135deg, #D4145A 0%, #FBB03B 100%)',
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  ];
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return gradients[Math.abs(hash) % gradients.length];
};
